export function queryStringToObject(url: string): any {
  return Object.fromEntries([...new URLSearchParams(url.split('?')[1])]);
}

export function objectToQueryString(queryParameters: any): string {
  if (!queryParameters) return "";
  return Object.entries(queryParameters).reduce(
    (queryString, [key, val]) => {
      const symbol = queryString.length === 0 ? '?' : '&';
      queryString += `${symbol}${key}=${val}`;
      return queryString;
    },
    ''
  )
}

function queryParamAssign(k: string, newdata: any, qso: any) {
  if (newdata[k] !== undefined && newdata[k] !== null) {
    qso[k] = newdata[k]
  } else {
    delete qso[k];
  }
}

export function updateQueryString(newdata: any) {

  const qso = queryStringToObject(window.location.href)

  Object
    .keys(newdata)
    .forEach(k => queryParamAssign(k, newdata, qso))

  const qss = objectToQueryString(qso)

  window.location.replace(window.location.origin + window.location.pathname + qss)
}

export function detectActive(url: string) {
  return location.pathname === encodeURI(url) ? 'active' : ''
}